import { sanitize } from 'utils/sanitizeString'

export const parseMessage = (message = '') => {
  // matches any link not wrapped with other characters
  const linkRegExp = new RegExp(/(^|\s)(http[s]?:\/\/[^\s]+)/gi)
  // matches markdown's link pattern for links: [text](#/some/relative/stark/url)
  const linkWithTextRegExp = new RegExp(/\[([^[]+)\]\(([^)]+)\)/g)
  // matches url tags <a href="http://..">label</a>
  const tagWithTextRegExp = new RegExp(/<a .*href=["']([^"']*)["'].*>([^<]*)<\/a.*>/gi)
  // replace <a href> with markdown []() so that it's skipped by sanitizer
  const messageInterim = message.replace(
    tagWithTextRegExp,
    (match, href, text) => `[${text}](${href})`
  )

  const sanitized = sanitize(messageInterim)
  const newNoteBody = sanitized
    .replace(
      linkRegExp,
      (full, empty, url) => `${empty}<a target='_blank' href='${url}'>${url}</a>`
    )
    .replace(
      linkWithTextRegExp,
      (match, text, href) => `<a target='_blank' href='${href}'>${text}</a>`
    )
  return newNoteBody
}
